module.exports = __webpack_public_path__ + "static/media/file-csv.bcfd1fae.svg";